import BreadcrumbLink from "components/elements/Breadcrumbs/BreadcrumbLink";
import { useWorkspace } from "lib/hooks/useWorkspace";
import { UrlObject } from "url";

export default function BreadcrumbWorkspace(p: {
  params: string[];
  href: UrlObject;
}) {
  const { workspace } = useWorkspace(p.params[0] && +p.params[0]);
  return (
    <BreadcrumbLink href={null}>
      {workspace?.name || "Loading..."}
    </BreadcrumbLink>
  );
}
